var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { darken } from '@theme-ui/color';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from './Button';
import { Fragment } from 'react';
export var MenuButton = function (_a) {
    var icon = _a.icon, iconTitle = _a.iconTitle, children = _a.children, subMenu = _a.subMenu, showSubMenu = _a.showSubMenu, props = __rest(_a, ["icon", "iconTitle", "children", "subMenu", "showSubMenu"]);
    return (jsx(Fragment, null,
        jsx(Button, __assign({ variant: "nav", size: "lg" }, props, { sx: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                '&.active': {
                    color: 'primary',
                },
                '.active + div > &': {
                    pl: 4,
                },
                '&:hover': {
                    color: 'primary',
                },
            } }),
            icon &&
                (children ? (jsx("div", { sx: {
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '1.5rem',
                        mr: 2,
                    } },
                    jsx(FontAwesomeIcon, { icon: icon, title: iconTitle }))) : (jsx(FontAwesomeIcon, { icon: icon, title: iconTitle }))),
            children && jsx("div", null, children)),
        subMenu && (jsx("div", { sx: {
                bg: darken('dark', 0.1),
                borderRadius: function (t) { return t.borderRadius; },
                display: showSubMenu ? 'block' : 'none',
                '& .active': {
                    color: 'highlight',
                },
                '.active + &': {
                    display: 'block',
                },
            } }, subMenu))));
};
//# sourceMappingURL=MenuButton.js.map